<template>
  <v-list-tile class="relatorio-analise-item">
    <v-list-tile-title class="relatorio-analise-link">
      <a :href="criarLinkDownload(relatorio.uriAtaAnalise)" v-if="relatorio.uriAtaAnalise" title="Download do Anexo"
         target="_blank" class="az-action-link-icon tabulacao-content">
        <span class="fileDownloadResposta">{{ relatorio.titulo }} - {{ relatorio.dataFimAnalise  | az-date('DD/MM/YYYY') }}</span>
      </a>

    </v-list-tile-title>
  </v-list-tile>
</template>

<script>

export default {
  name: 'CredenciamentoAtualizacaoAcoesRelatorioAnalise',
  props: {
    relatorio: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped lang="stylus">

    .relatorio-analise-link .fileDownloadResposta
        line-height 24px
        font-size 14px
        margin 0
        border-bottom none !important
        color black !important
        text-decoration none !important

    div.relatorio-analise-item[role=listitem]:not(:last-child)
        border-bottom 1px solid #81818185 !important

 </style>